import { Colors } from '@ab-core/colors';
import { RADIUS } from '@ab-core/radius';
import Text from '@ab-core/text';
import styled from 'styled-components';

export const TotalCartPrice = styled.div`
    display: flex;
    height: 40px;
    padding: 0 10px;
    background: ${Colors.backgroundShade};
    border-radius: ${RADIUS.MINIMAL};
    align-items: center;
    column-gap: 10px;
    padding: 20px 10px;
`;

export const Total = styled(Text)`
    margin-right: auto;
`;
